export const enClientPortalPlaygroundPages = {
    playground: {
        shared: {
            header: {
                defaultBreadcrumbTitle: 'Tools',
                betaLabel: 'Beta',
                learnMore: 'Learn more',
                close: 'Close',
                modalTitle: 'More about {{title}}',
            },
            feedback: {
                payload: {
                    category: 'Category',
                    incident: 'Incident',
                },
                tool: {
                    triggerLabel: 'Give feedback',
                    tooltip: 'Give feedback',
                    title: 'Give feedback',
                    close: 'Close',
                    cancel: 'Cancel',
                    submit: 'Submit',
                    categoryLabel: 'Type of feedback',
                    descriptionLabel: 'Description',
                    descriptionTooltip: 'Concrete examples help us most.',
                    descriptionFieldLabel: 'What happened? What did you expect?',
                    descriptionAriaLabel: 'Description',
                    incidentLabel: 'Critical issue',
                    incidentTooltip: 'Critical issues include errors that block you or situations where you need immediate help.',
                    errorMessage:
                        'Unfortunately, an error occurred while submitting your feedback. Please make sure your ad blocker is disabled on this page and try again. If the error persists, contact support@einwert.com.',
                    successMessage: 'Thank you for your feedback!',
                    options: [
                        {
                            title: 'Something is not working',
                            description: 'e.g. error message, incorrect result, crash',
                        },
                        {
                            title: 'Result was inaccurate',
                            description: 'e.g. incorrect AI interpretation, missing answers',
                        },
                        {
                            title: 'Something is unclear',
                            description: 'e.g. unclear workflow, confusing output',
                        },
                        {
                            title: 'Suggestion for improvement',
                            description: 'e.g. idea, missing feature, request',
                        },
                        {
                            title: 'Praise',
                            description: 'e.g. time saved, noticeable help',
                        },
                    ],
                },
            },
            pdfPreview: {
                searchLabel: 'Search',
                searchPlaceholder: 'Search PDF',
                previousResult: 'Previous result',
                nextResult: 'Next result',
                noResults: 'No results found.',
                searchResultMessage: 'Result {{current}} of {{total}} (page {{page}})',
                pdfLoadError: 'PDF could not be displayed.',
                previousPage: 'Previous page',
                nextPage: 'Next page',
                page: 'Page',
                zoomOut: 'Zoom out',
                zoomIn: 'Zoom in',
            },
            upload: {
                fileSizeErrorMessage: 'The file is larger than 20 MB. Please compress the PDF and try again.',
                replacePdf: 'Replace PDF',
                uploadPdf: 'Upload PDF',
                uploadValuationPdf: 'Upload {{report}} PDF',
                cancel: 'Cancel',
                valuationPdf: '{{report}} PDF',
                dropDescription: 'Drop a PDF here or click to select one.',
                emptyTitle: 'Upload {{report}} PDF',
                sampleButton: 'Try example',
                sampleTooltip: 'Try the einwert sample report.',
                uploadTooltip: 'Upload {{report}} as PDF',
                restartAnalysis: 'Restart analysis',
                removeFile: 'Remove file',
            },
        },
        tenantListImport: {
            title: 'Tenant list to Excel',
            infoText: 'Extract your tenant list, review the result and download it in the einwert Excel format.',
            emptyDescription: 'Drop a tenant list here or select a file. Excel (.xlsx, .xlsm, .xls) or PDF, up to 20 MB.',
            replaceFile: 'Replace file',
            readyToDownload: 'Ready to download',
            format: {
                title: 'einwert Excel format',
                template:
                    'The Excel file presents the key tenant information in a standardized format that is used as a basis for valuation reports.',
                periods:
                    'This format supports up to four rent graduations, three rent-free periods and three vacancy periods with start and end dates per unit.',
                remarks:
                    'Additional periods and vacancies without complete dates are kept only in the remarks; missing market rents stay blank.',
            },
            exportLimitations:
                'Affected units: {{count}}. Additional rent graduations, periods or vacancies without complete dates are saved only in the remarks. These details will not be imported as structured data when using the template.',
        },
        valXmlExtractor: {
            title: 'PDF to {{valXml}}',
            infoText: 'Automatically read the key data from your report and export it as a {{valXml}} file.',
            infoModalItems: [
                'Our tool uses AI to automate reading and exporting data from report PDFs and provides the data as a {{valXml}} download.',
                '{{valXml}} is a standardized file format developed by the German BIIS association for exchanging valuation-related data.',
                'Not all valuation methods can be represented in {{valXml}} format.',
                'AI can make mistakes. Please review the data before using it. You can add, change, or remove data manually in the tool.',
                'Need the data in another format? Send us feedback.',
            ],
            emptyDescription: 'Select a report to extract key figures and export them as {{valXml}}.',
            aiResponse: {
                language: 'Englisch (en-US)',
                requiredImportDefaultNote: 'Required field for backend import. No explicit value found in the PDF; default value set.',
            },
            progress: {
                defaultExtraction: 'Extracting key figures',
                extractingSection: 'Extracting {{section}}',
            },
            errors: {
                missingReviewData: 'There is no AI extraction to review yet.',
                missingReviewKpis: 'No KPIs have been extracted yet that could be reviewed.',
                noReadableText: 'No readable text was found in the document.',
                pdfProcessing: 'The PDF file could not be processed. Please check the document and try again.',
                pdfProviderFit: 'The PDF could not be prepared for AI processing. Please check or compress the document and try again.',
                samplePdf: 'The sample report could not be loaded.',
                valXmlBuild: 'The {{valXml}} could not be created. Please add missing {{valXml}} paths and try again.',
                authExpired: 'Not signed in or session expired. Please sign in again.',
                forbidden: 'Access denied. You do not have permission to use the AI feature.',
                endpointMissing: 'AI endpoint not found. Check VITE_BACKEND_ROUTE and backend availability.',
                rateLimit: 'Limit reached. Please try again later.',
                server: 'AI server error. Please try again later.',
                missingToken: 'Not signed in. Please sign in and try again.',
                responseMissingJson: 'The AI response did not contain JSON.',
                responseInvalidJson: 'The AI response was not valid JSON.',
                responseInvalidFormat: 'The extraction response was not in the expected JSON format.',
                unknown: 'Unknown error while fetching the AI response.',
                genericAiErrorWithMessage: 'Error ({{code}}): {{message}}',
                genericAiError: 'Error ({{code}}) during the AI call.',
            },
            secondaryCheck: {
                invalidJson: 'The review response was not valid JSON. Please check the AI response or start the review again.',
                invalidFormat: 'The review response was not in the expected JSON format.',
                missingValueReviewNote: 'Missing value according to AI review.',
                noChanges: 'Additional review complete - no changes.',
                joinSeparator: ' and ',
                newEntries_one: '{{count}} new entry added',
                newEntries_other: '{{count}} new entries added',
                valueChanges_one: 'Values updated for {{count}} entry',
                valueChanges_other: 'Values updated for {{count}} entries',
                proposedChanges_one: '{{count}} entry marked with a suggested change',
                proposedChanges_other: '{{count}} entries marked with suggested changes',
                confidenceReduced_one: 'Confidence reduced for {{count}} entry',
                confidenceReduced_other: 'Confidence reduced for {{count}} entries',
            },
            kpiSection: {
                validation: {
                    missingValXmlField: 'Please select a {{valXml}} field',
                    missingValue: 'Please enter a value',
                    kpiAdded: 'KPI added',
                },
                labels: {
                    review: 'Review',
                    page: 'Page',
                    confidence: 'Confidence',
                    manualConfidence: 'Manual',
                    valXmlPath: '{{valXml}} path',
                    explanation: 'Explanation',
                    notes: 'Notes',
                    codeInterpreterUsed: 'Code Interpreter used',
                    title: 'Key figures',
                    valXml: '{{valXml}}',
                },
                actions: {
                    removeKpi: 'Remove key figure',
                    copyValue: 'Copy value',
                    acceptProposal: 'Accept suggestion',
                    rejectProposal: 'Reject suggestion',
                    addKpi: 'Add key figure',
                    addMissingKpi: 'Add missing key figure',
                    reviewTooltip: 'Review all values again with AI',
                    reviewRunning: 'Review running',
                    review: 'Review',
                },
                placeholders: {
                    value: 'Enter value',
                },
                feedback: {
                    valueCopied: 'Value copied to clipboard',
                    valXmlUnavailable: '{{valXml}} is not available yet',
                    valXmlExportStarted: '{{valXml}} export started',
                    extractingInitial: 'Extracting key figures',
                    extractingMore: 'Extracting more key figures',
                },
                booleanLabels: {
                    true: 'Yes',
                    false: 'No',
                },
                generalSections: {
                    appraiserInspection: 'Appraiser & inspection',
                    valuationResults: 'Valuation results',
                    costsDeductions: 'Costs & deductions',
                    addressOwner: 'Address & owner',
                    otherKeyFigures: 'Other key figures',
                },
                rentalSections: {
                    archive: 'Archive',
                    businessGeneral: 'Commercial',
                    gastronomy: 'Gastronomy',
                    hotel: 'Hotel',
                    indoorParking: 'Indoor parking',
                    leisure: 'Leisure',
                    office: 'Office',
                    outdoorParking: 'Outdoor parking',
                    residential: 'Residential',
                    retail: 'Retail',
                    social: 'Social',
                    storage: 'Storage',
                    otherUsage: 'Other usage',
                },
                valXmlFields: {
                    labels: {
                        'BIISValuationData.General.Address.Country': 'Country code',
                        'BIISValuationData.General.Address.PostCode': 'Postal code',
                        'BIISValuationData.General.Address.Street': 'Street',
                        'BIISValuationData.General.Address.Town': 'Town',
                        'BIISValuationData.General.ObjNoOwner': 'Owner object reference',
                        'BIISValuationData.General.ObjNoOwnerTechnical': 'Technical owner object reference',
                        'BIISValuationData.General.Owner': 'Owner',
                        'BIISValuationData.General.PortfolioName': 'Portfolio name',
                        'BIISValuationData.ValuationResults.AncillaryTypeOfUse': 'Ancillary type of use',
                        'BIISValuationData.ValuationResults.CalculatedYearOfConstruction': 'Economic year of construction',
                        'BIISValuationData.ValuationResults.CapitalizationRate': 'Capitalization rate',
                        'BIISValuationData.ValuationResults.CoValuer1Name': 'First co-appraiser name',
                        'BIISValuationData.ValuationResults.CoValuer2Name': 'Second co-appraiser name',
                        'BIISValuationData.ValuationResults.CostApproach': 'Cost approach result',
                        'BIISValuationData.ValuationResults.DateOfAppraisal': 'Valuation date',
                        'BIISValuationData.ValuationResults.FitOutQuality': 'Fit-out quality',
                        'BIISValuationData.ValuationResults.FloorToAreaRatio': 'Floor area ratio',
                        'BIISValuationData.ValuationResults.Floors': 'Floors',
                        'BIISValuationData.ValuationResults.LandSize': 'Land size',
                        'BIISValuationData.ValuationResults.LandValue': 'Land value',
                        'BIISValuationData.ValuationResults.LocationQuality': 'Location quality',
                        'BIISValuationData.ValuationResults.MainTypeOfUse': 'Main type of use',
                        'BIISValuationData.ValuationResults.MainValuerDateOfInspection': 'Lead appraiser inspection date',
                        'BIISValuationData.ValuationResults.MainValuerName': 'Lead appraiser name',
                        'BIISValuationData.ValuationResults.MaintenanceExpenses': 'Maintenance expenses',
                        'BIISValuationData.ValuationResults.ManagementCosts': 'Management costs',
                        'BIISValuationData.ValuationResults.MarketValue': 'Market value',
                        'BIISValuationData.ValuationResults.NormalTotalEconomicLife': 'Normal total economic life',
                        'BIISValuationData.ValuationResults.OriginalYearOfConstructionAsYearNumber': 'Original year of construction',
                        'BIISValuationData.ValuationResults.OtherOperatingExpenses': 'Other operating expenses',
                        'BIISValuationData.ValuationResults.PriceOfSale': 'Sale price',
                        'BIISValuationData.ValuationResults.PurchasePrice': 'Purchase price',
                        'BIISValuationData.ValuationResults.QualityDateOfAppraisalAsDate': 'Quality date of appraisal',
                        'BIISValuationData.ValuationResults.RemainingEconomicLife': 'Remaining economic life',
                        'BIISValuationData.ValuationResults.RentAllowance': 'Rent loss allowance',
                        'BIISValuationData.ValuationResults.RunningCosts': 'Non-recoverable operating costs',
                        'BIISValuationData.ValuationResults.ShareAncillaryTypeOfUse': 'Ancillary use share',
                        'BIISValuationData.ValuationResults.ShareMainTypeOfUse': 'Main use share',
                        'BIISValuationData.ValuationResults.SiteCoverageRatio': 'Site coverage ratio',
                        'BIISValuationData.ValuationResults.StateOfCompletion': 'State of completion',
                        'BIISValuationData.ValuationResults.StructuralCondition': 'Structural condition',
                        'BIISValuationData.ValuationResults.TotalGrossFloorSpace': 'Total gross floor area',
                        'BIISValuationData.ValuationResults.TotalRentableArea': 'Total rentable area',
                        'BIISValuationData.ValuationResults.TypeOfOwnership': 'Type of ownership',
                        'BIISValuationData.ValuationResults.ValueByIncomeApproach': 'Income approach value',
                        'BIISValuationData.ValuationResults.ValueByIncomeApproachWithoutPremiumsDiscounts':
                            'Income approach value without premiums/discounts',
                        'BIISValuationData.ValuationResults.YearOfLatestMajorRenovation': 'Year of latest major renovation',
                        'DataSupplier.Short': 'Data supplier/recipient',
                    },
                    descriptions: {
                        'BIISValuationData.General.Address.Country': 'Country code of an address, represented as an ISO country code.',
                        'BIISValuationData.General.Address.PostCode': 'Postal code of an address.',
                        'BIISValuationData.General.Address.Street': 'Street of an address.',
                        'BIISValuationData.General.Address.Town': 'Town or city of an address.',
                        'BIISValuationData.General.ObjNoOwner': 'Object number or object reference used by the owner.',
                        'BIISValuationData.General.ObjNoOwnerTechnical':
                            'Additional owner object number or object reference used for data processing.',
                        'BIISValuationData.General.Owner': 'Owner of the property.',
                        'BIISValuationData.General.PortfolioName':
                            'Name of the portfolio, fund, or special fund that includes the property.',
                        'BIISValuationData.ValuationResults.AncillaryTypeOfUse':
                            'Ancillary use type in the property. Allowed values include office, retail, industrial, archive, gastronomy, hotel, residential, leisure, social, general commercial, parking, and unknown.',
                        'BIISValuationData.ValuationResults.CalculatedYearOfConstruction': 'Economic year of construction.',
                        'BIISValuationData.ValuationResults.CapitalizationRate': 'Capitalization rate.',
                        'BIISValuationData.ValuationResults.CoValuer1Name': 'Name of the first co-appraiser.',
                        'BIISValuationData.ValuationResults.CoValuer2Name': 'Name of the second co-appraiser.',
                        'BIISValuationData.ValuationResults.CostApproach': 'Result of the cost approach.',
                        'BIISValuationData.ValuationResults.DateOfAppraisal': 'Valuation date.',
                        'BIISValuationData.ValuationResults.FitOutQuality': 'Fit-out quality: very high, high, medium, simple, or unknown.',
                        'BIISValuationData.ValuationResults.FloorToAreaRatio': 'Floor area ratio.',
                        'BIISValuationData.ValuationResults.Floors': 'Number or description of floors.',
                        'BIISValuationData.ValuationResults.LandSize': 'Land size in the report area unit.',
                        'BIISValuationData.ValuationResults.LandValue': 'Land value.',
                        'BIISValuationData.ValuationResults.LocationQuality': 'Location quality: 1a, 1b, 2a, 2b, 3, or unknown.',
                        'BIISValuationData.ValuationResults.MainTypeOfUse':
                            'Main use type in the property. Allowed values include office, retail, industrial, archive, gastronomy, hotel, residential, leisure, social, general commercial, parking, and unknown.',
                        'BIISValuationData.ValuationResults.MainValuerDateOfInspection': 'Date of the lead appraiser property inspection.',
                        'BIISValuationData.ValuationResults.MainValuerName': 'Name of the lead appraiser.',
                        'BIISValuationData.ValuationResults.MaintenanceExpenses':
                            'Maintenance expenses as an absolute amount in the report currency.',
                        'BIISValuationData.ValuationResults.ManagementCosts':
                            'Management costs as an absolute amount in the report currency.',
                        'BIISValuationData.ValuationResults.MarketValue': 'Market value.',
                        'BIISValuationData.ValuationResults.NormalTotalEconomicLife': 'Normal total economic life.',
                        'BIISValuationData.ValuationResults.OriginalYearOfConstructionAsYearNumber':
                            'Original year of construction, based on the oldest building section, as a four-digit year.',
                        'BIISValuationData.ValuationResults.OtherOperatingExpenses':
                            'Other operating expenses as an absolute amount in the report currency.',
                        'BIISValuationData.ValuationResults.PriceOfSale': 'Sale price stated in the report.',
                        'BIISValuationData.ValuationResults.PurchasePrice': 'Purchase price in the report currency.',
                        'BIISValuationData.ValuationResults.QualityDateOfAppraisalAsDate': 'Quality date of appraisal as a date.',
                        'BIISValuationData.ValuationResults.RemainingEconomicLife': 'Remaining economic life.',
                        'BIISValuationData.ValuationResults.RentAllowance':
                            'Rent loss allowance as an absolute amount in the report currency.',
                        'BIISValuationData.ValuationResults.RunningCosts':
                            'Non-recoverable operating costs as an absolute amount in the report currency.',
                        'BIISValuationData.ValuationResults.ShareAncillaryTypeOfUse':
                            'Percentage share of the first ancillary use based on income.',
                        'BIISValuationData.ValuationResults.ShareMainTypeOfUse': 'Percentage share of the main use based on income.',
                        'BIISValuationData.ValuationResults.SiteCoverageRatio': 'Site coverage ratio.',
                        'BIISValuationData.ValuationResults.StateOfCompletion':
                            'State of completion: F=completed, I=under construction, P=planned, 0=unknown.',
                        'BIISValuationData.ValuationResults.StructuralCondition':
                            'Structural condition: very good, good, average, poor, or unknown.',
                        'BIISValuationData.ValuationResults.TotalGrossFloorSpace': 'Total gross floor area in the report area unit.',
                        'BIISValuationData.ValuationResults.TotalRentableArea': 'Total rentable area in the report area unit.',
                        'BIISValuationData.ValuationResults.TypeOfOwnership':
                            'Ownership type: 0=unknown, 1=real right of use, 2=heritable building right, 3=mixed ownership, 4=partial ownership, 5=full ownership, 6=volume ownership.',
                        'BIISValuationData.ValuationResults.ValueByIncomeApproach':
                            'Income approach result, including premiums and discounts.',
                        'BIISValuationData.ValuationResults.ValueByIncomeApproachWithoutPremiumsDiscounts':
                            'Income approach value from market-standard income, excluding premiums and discounts.',
                        'BIISValuationData.ValuationResults.YearOfLatestMajorRenovation':
                            'Year of the latest major renovation or extension as a four-digit year.',
                        'DataSupplier.Short': 'Name of the data supplier or recipient.',
                    },
                    rentalUsageLabels: {
                        Archive: 'Archive',
                        Archiv: 'Archive',
                        BusinessGeneral: 'Commercial',
                        'Gewerbe Allgemein': 'Commercial',
                        Gastro: 'Gastronomy',
                        Hotel: 'Hotel',
                        Indoorparking: 'Indoor parking',
                        StellplaetzeInnen: 'Indoor parking',
                        Leisure: 'Leisure',
                        Freizeit: 'Leisure',
                        MiscArea1: 'Other area 1',
                        Sonstigeflächen1: 'Other area 1',
                        MiscArea2: 'Other area 2',
                        Sonstigeflächen2: 'Other area 2',
                        Miscnumbers1: 'Other count 1',
                        SonstigeAnzahl1: 'Other count 1',
                        Miscnumbers2: 'Other count 2',
                        SonstigeAnzahl2: 'Other count 2',
                        Office: 'Office',
                        Büro: 'Office',
                        Outsideparking: 'Outdoor parking',
                        StellplaetzeAussen: 'Outdoor parking',
                        Residential: 'Residential',
                        Wohnen: 'Residential',
                        Retail: 'Retail',
                        Handel: 'Retail',
                        Social: 'Social',
                        Soziales: 'Social',
                        Storage: 'Storage',
                        Lager: 'Storage',
                    },
                    rentalFieldLabels: {
                        ContractualAnnualRent: 'Contractual annual rent',
                        EstimatedAnnualRentForLetArea: 'Market rent for let area',
                        EstimatedAnnualRentForVacantArea: 'Market rent for vacant area',
                        EstimatedAnnualRentForLetNumbers: 'Market rent for let units',
                        EstimatedAnnualRentForVacantNumbers: 'Market rent for vacant units',
                        EstimatedAnnualRentLet: 'Market rent for let area/units',
                        EstimatedAnnualRentVacant: 'Market rent for vacant area/units',
                        LetArea: 'Let area',
                        VacantArea: 'Vacant area',
                        LetNumbers: 'Let units',
                        VacantNumbers: 'Vacant units',
                    },
                    rentalDescription: 'Rent roll: {{usage}} - {{field}}.',
                },
                addModal: {
                    title: 'Add new key figure',
                    add: 'Add',
                    cancel: 'Cancel',
                    fieldLabel: 'Key figure',
                    fieldPlaceholder: 'Select key figure',
                    valueLabel: 'Value',
                    fallbackRentalUsage: 'General',
                    generalGroupLabel: 'General key figures',
                    rentalGroupLabel: 'Rent roll - {{usage}}',
                    expectedType: 'Expected type: {{type}}',
                },
            },
        },
        pdfValidator: {
            title: 'AI plausibility check',
            infoText: 'Use AI to check your reports with the plausibility check.',
            upload: {
                sampleTooltip: 'Try the einwert sample report',
            },
            infoModalItems: [
                'A combination of predefined standard checks and your own review questions gives you quick answers about the current report.',
                'You can load the review questions from the previous run and quickly repeat the same checks on a new report.',
                'Standard checks run automatically. You can add your own review questions and queue them by clicking "{{startLabel}}".',
                'Clicking an answer takes you to the relevant report passage so you can verify the AI results.',
                'You can add your own comments in the notes field and share them afterwards.',
            ],
            emptyDescription: 'Select a report to start the plausibility check.',
            answerLabels: {
                yes: 'Yes',
                no: 'No',
                textAnswer: 'Text answer',
                unknown: 'Unknown',
            },
            errors: {
                noClearAnswer: 'No clear answer was found in the document.',
                retryValidation:
                    'Part of the plausibility check failed. Click "{{startLabel}}" again so all open checks and review questions can be answered.',
                noReadableText: 'No readable text was found in the document.',
                tableOfContentsLoadingFailed: 'The table of contents could not be loaded. The plausibility check can still be started.',
                pdfProcessing: 'The PDF file could not be processed. Please check the document and try again.',
                pdfProviderFit: 'The PDF could not be prepared for AI processing. Please check or compress the document and try again.',
                samplePdf: 'The sample report could not be loaded.',
                sessionExpiredTitle: 'Session expired',
                sessionExpiredDescription:
                    'The AI session was inactive for more than 30 minutes and has expired. Reload the page to continue with a fresh session.',
            },
            progress: {
                tableOfContents: 'Loading table of contents',
            },
            standardChecks: {
                title: 'Standard checks',
                tooltip:
                    'These sample standard checks are currently designed for follow-up valuations. Additional valuation types will follow.',
                questions: [
                    {
                        id: 'standard_check_aktuelle_quellen',
                        question: 'The market data sources are not older than two years before the valuation date',
                    },
                    {
                        id: 'standard_check_grundbuchauszug',
                        question: 'The land register extract is no more than three years old',
                    },
                    {
                        id: 'standard_check_wirtschaftliches_baujahr',
                        question: 'The economic year of construction has not changed',
                    },
                    {
                        id: 'standard_check_besichtigung_hauptgutachter',
                        question: 'The inspection was carried out, among others, by the lead appraiser',
                    },
                ],
            },
            tableOfContents: {
                title: 'Table of contents',
                loading: 'Loading table of contents',
                empty: 'No main sections detected.',
                pending: 'The table of contents will be created automatically after upload.',
            },
            notes: {
                title: 'Notes',
                copy: 'Copy notes',
                placeholder: 'Collect your comments here',
                textEditor: {
                    toolbar: {
                        textStyle: 'Text style',
                        bold: 'Bold',
                        italic: 'Italic',
                        bulletedList: 'Bulleted list',
                        numberedList: 'Numbered list',
                        headingOptions: {
                            paragraph: 'Text',
                            h2: 'Headline 1',
                            h3: 'Headline 2',
                            h4: 'Headline 3',
                            h5: 'Headline 4',
                        },
                    },
                },
            },
            questions: {
                title: 'Review questions',
                queued: 'Review questions queued',
                start: 'Start the plausibility check',
                startInfo: 'Start the plausibility check to answer unanswered questions.',
                newPlaceholder: 'New question ...',
                create: 'Create review question',
                emptyWithPersisted:
                    'Add your own review questions, start with sample questions, or load questions from the previous plausibility check.',
                emptyWithoutPersisted: 'Add your own review questions or start with sample questions.',
                generateExamples: 'Generate sample questions',
                loadPast: 'Load previous questions',
                save: 'Save review question',
                cancelEdit: 'Cancel editing',
                edit: 'Edit review question',
                delete: 'Delete review question',
                examples: [
                    'What are the main reasons for the changes compared with the previous valuation?',
                    'Were the CapEx measures described clearly enough for an independent third party to understand?',
                    'Was the change in remaining useful life described clearly enough for an independent third party to understand?',
                    'There are no logical contradictions in the report. If there are, list all of them.',
                    'There are no spelling mistakes in the document. If there are, list all of them.',
                    'There are no remaining placeholders in the document. If there are, list all of them.',
                    'The comparison with the previous valuation calculates the correct absolute and percentage change.',
                ],
            },
            actions: {
                reloadPage: 'Reload page',
            },
        },
    },
}
